import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'yesNo',
  pure: true,
  standalone: true
})
export class YesNoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: string | boolean): string {
    return value ? this.translate.instant('common.yes') : this.translate.instant('common.no');
  }
}
